// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kf-0";
export var buttonContainer = "_kf-3";
export var cancelButton = "_kf-4";
export var headerSection = "_kf-6";
export var headerTitle = "_kf-9";
export var messageSideLeft = "_kf-1";
export var messageSideRight = "_kf-2";
export var orderNumberContainer = "_kf-7";
export var orderNumberLabel = "_kf-8";
export var submitButton = "_kf-5";